// bottle animation
gsap.registerPlugin(ScrollTrigger);
gsap.from(".title-left-bottle img.bootlemilkk", {
  y: -180,
  duration: 1.6,
  ease: "power3.out",
  scrollTrigger: {
    trigger: "#clean-protein",
    scroller: "body",
    markers: false,
    start:" 70% 50%"
  }
});

gsap.to(".title-left-bottle img.milksplashimg", {
  scale:1.16,
  delay:.5,
  duration: .5,
  scrollTrigger: {
    trigger: "#clean-protein",
    scroller: "body",
    start:" 70% 50%"
  }
});



 // graph animation
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const dot = document.getElementById('draggableDot');
const badge = document.getElementById('percentageBadge');
const curvePath = document.getElementById('redCurvePath');
const section = document.querySelector('.absorption-compare-section');
const isolateImageContainer = document.getElementById('isolateImageContainer');
const isolateCaption = document.getElementById('isolateCaption');
const card = document.querySelector('.absorption-compare-card');

let currentPercentage = 60;
let animationHasPlayed = false;
let imageShown = false;

// Get the bounding box of the curve
const pathLength = curvePath.getTotalLength();

// Helper: position badge at top-left of the dot (inside the card)
function positionBadgeNearDot(offsetX = 12, offsetY = 12) {
  const cardRect = card.getBoundingClientRect();
  const dotRect = dot.getBoundingClientRect();
  const badgeRect = badge.getBoundingClientRect();

  const dotCenterX = dotRect.left + dotRect.width / 2;
  const dotCenterY = dotRect.top + dotRect.height / 2;

  // left/top relative to card, putting badge to the left & above the dot
  const left = dotCenterX - cardRect.left - badgeRect.width - offsetX;
  const top = dotCenterY - cardRect.top - badgeRect.height - offsetY;

  gsap.set(badge, { left, top });
}

// Function to get point at percentage along the path
function getPointAtPercentage(percentage) {
  // Convert percentage (0-100) to path position (0-1)
  const progress = percentage / 100;

  // Get point along the path
  const point = curvePath.getPointAtLength(progress * pathLength);

  // Adjust for SVG viewBox and container position
  const svg = curvePath.closest('svg');
  const svgRect = svg.getBoundingClientRect();
  const viewBox = svg.viewBox.baseVal;

  // Convert SVG coordinates to screen coordinates
  const xPercent = point.x / viewBox.width;
  const yPercent = point.y / viewBox.height;

  const screenX = svgRect.left + (xPercent * svgRect.width);
  const screenY = svgRect.top + (yPercent * svgRect.height);

  return {
    x: screenX,
    y: screenY
  };
}

// Function to show isolate image
function showIsolateImage() {
  if (!imageShown) {
    imageShown = true;
    // Add show class to trigger CSS animation
    card.classList.add('show-image');

    // Also use GSAP for additional effects
    gsap.to(isolateImageContainer, {
      scale: 1,
      duration: 0.6,
      ease: "back.out(1.7)"
    });
  }
}

// Function to hide isolate image
function hideIsolateImage() {
  imageShown = false;
  // Remove show class to hide image
  card.classList.remove('show-image');
}

// Set initial position (around 30% of path)
const initialPoint = getPointAtPercentage(30); // Starting around left product

gsap.set(dot, {
  x: initialPoint.x,
  y: initialPoint.y
});

// Position badge relative to dot (top-left)
positionBadgeNearDot();

// Hide isolate image initially
hideIsolateImage();

// Function to animate dot along the curve
function animateDotAlongCurve() {
  if (animationHasPlayed) return;

  animationHasPlayed = true;

  // Reset colors
  gsap.to(dot.querySelector('.inner'), { backgroundColor: "#ff6b6b", duration: 0.3 });

  // Create animation timeline
  const tl = gsap.timeline({
    onComplete: () => {
      // Final celebration animation
      gsap.to(dot, {
        scale: 1.2,
        duration: 0.3,
        yoyo: true,
        repeat: 1
      });
    }
  });

  // Animate from start to end of curve
  tl.to(dot, {
    duration: 2,
    ease: "power2.inOut",
    motionPath: {
      path: curvePath,
      align: curvePath,
      alignOrigin: [0.5, 0.5],
      start: 0.3, // Start at 30% of the curve (near left product)
      end: 1     // Go to end of curve
    },
    onUpdate: function () {
      // Calculate current percentage based on progress
      const progress = this.progress();
      currentPercentage = Math.min(60 + Math.round(progress * 35), 95);

      // Update badge position to follow dot
      positionBadgeNearDot();

      // Update badge text
      const badgeInner = badge.querySelector('.perceninner');
      badgeInner.innerHTML = `${currentPercentage}% <span class="small">Absorption</span>`;

      // Change color when near top (85%+)
      if (currentPercentage >= 85) {
        gsap.to(curvePath, { stroke: "", duration: 0.5 });
        gsap.to(dot.querySelector('.inner'), { backgroundColor: "#fc4444", duration: 0.5, opacity: 1, visibility: 'visible' });
        gsap.to(dot, { backgroundColor: "#fc44447a", scale: 2, duration: 0.5 });
        gsap.to(badgeInner, { background: "#fee", duration: 0.5 });
        gsap.to(badge, { background: "#f9cfcf", duration: 0.5 });
      }

      // Show isolate image when reaching 85% absorption
      if (currentPercentage >= 85 && !imageShown) {
        showIsolateImage();
      }
    }
  });
}

// ScrollTrigger to detect when section is in view
ScrollTrigger.create({
  trigger: section,
  start: "top 80%",   // When top of section is 80% from top of viewport
  end: "bottom 20%",
  onEnter: () => {
    // Start animation when section comes into view
    if (!animationHasPlayed) {
      animateDotAlongCurve();
    }
  },
  onEnterBack: () => {
    // Restart animation when scrolling back up
    if (animationHasPlayed) {
      resetAnimation();
      setTimeout(animateDotAlongCurve, 300);
    }
  },
  markers: false
});

// Function to reset animation
function resetAnimation() {
  animationHasPlayed = false;

  // Reset to starting position
  const startPoint = getPointAtPercentage(30);
  gsap.set(dot, {
    x: startPoint.x,
    y: startPoint.y
  });

  // Reset percentage and badge text
  currentPercentage = 60;
  const badgeInner = badge.querySelector('.perceninner');
  badgeInner.innerHTML = `${currentPercentage}% <span class="small">Absorption</span>`;

  // Reposition badge relative to dot
  positionBadgeNearDot();

  // Reset colors
  gsap.to(curvePath, { stroke: "#ff0000", duration: 0.3 });
  gsap.to(dot.querySelector('.inner'), { backgroundColor: "#ff6b6b", duration: 0.3 });
  gsap.to(badgeInner, { background: "linear-gradient(180deg, #fefefe, #e0e0e0)", duration: 0.3 });
  gsap.to(badge, { background: "#b3aca99e", duration: 0.3 });

  // Hide isolate image
  hideIsolateImage();
}
 